import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Skeleton from 'react-loading-skeleton';
import classes from './CategorySidebar.module.scss';
import { Button } from '@/components';
import { viewportContext } from '@/context/viewport.context';
import { collectionPropType } from '@/propTypes/collection';

const CategorySidebar = ({ collection, t, categoriesLoading, activeCategoryId, isOwner, isEditor, addNewCategory }) => {
  const router = useRouter();
  const { isMobileOrTablet } = useContext(viewportContext);

  const loadCategory = (categorySlug) => {
    router.push(`/collections/${collection.slug}/${categorySlug}`);
  };

  const renderCategoriesLoading = () => (
    <>
      <Skeleton height={40} style={{ marginBottom: '5px' }} />
      <Skeleton height={40} style={{ marginBottom: '5px' }} />
      <Skeleton height={40} style={{ marginBottom: '5px' }} />
    </>
  );

  const hasUncategorized = collection?.fetchable_list_items?.length > 0;

  const renderCategoriesList = () => (
    <>
      {hasUncategorized && (
        <Col className={[classes.categoryItem, activeCategoryId === null ? classes.categoryItemActive : ''].join(' ')}>
          <span onClick={() => router.push(`/collections/${collection.slug}`)} className={classes.categoryName}>
            {t('Uncategorized')}
          </span>
        </Col>
      )}
      {collection?.categories?.map((item) => (
        <Col key={item.id} className={[classes.categoryItem, activeCategoryId === item.id ? classes.categoryItemActive : ''].join(' ')}>
          <span onClick={() => loadCategory(item.slug)} className={classes.categoryName}>
            {item.title}
          </span>
        </Col>
      ))}
      <Row>
        <Col className={classes.addCategoryBtn}>
          {(isOwner || isEditor) && (
            <Button
              dataCy="button-add-category"
              type="default"
              icon={{ style: 'fas', font: 'plus' }}
              text={t('Add new category')}
              onButtonClick={addNewCategory}
            />
          )}
        </Col>
      </Row>
    </>
  );

  return (
    <Col md="3">
      <Card className={classes.categoryListCard}>
        <Accordion defaultActiveKey={isMobileOrTablet ? null : '0'}>
          <Accordion.Item eventKey="0">
            <Card.Body>
              <Accordion.Header className={classes.accordionHeader}>
                <Row>
                  <Col className={classes.categoryTitle}>{t('Categories')}</Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className={classes.accordionBody}>
                <div className={classes.categoriesList}>{categoriesLoading ? renderCategoriesLoading() : renderCategoriesList()}</div>
              </Accordion.Body>
            </Card.Body>
          </Accordion.Item>
        </Accordion>
      </Card>
    </Col>
  );
};

CategorySidebar.propTypes = {
  collection: collectionPropType.isRequired,
  categoriesLoading: PropTypes.bool,
  activeCategoryId: PropTypes.number,
  isOwner: PropTypes.bool,
  isEditor: PropTypes.bool,
  addNewCategory: PropTypes.func.isRequired
};

CategorySidebar.defaultProps = {
  categoriesLoading: false,
  activeCategoryId: null,
  isOwner: false,
  isEditor: false
};

export default CategorySidebar;
